import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";


const faqImage = process.env.PUBLIC_URL + "/assets/images/image11.png";


const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideInLeft = keyframes`
  from { opacity: 0; transform: translateX(-100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const slideInRight = keyframes`
  from { opacity: 0; transform: translateX(100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 60px 20px;
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 40px 15px;
  }
`;


const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: #228B22;
  text-align: left;
  width: 80%;
  margin-bottom: 20px;
  span {
    color: #E60000;
  }
  animation: ${slideInLeft} 1s ease-in-out;

  @media (max-width: 768px) {
    font-size: 24px;
    text-align: center;
    width: 100%;
  }
`;


const FAQContainer = styled.div`
  display: flex;
  gap: 40px;
  width: 80%;
  background: white;
  padding: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
    width: 100%;
  }
`;


const FAQContent = styled.div`
  flex: 1;
  animation: ${slideInRight} 1s ease-in-out;
`;


const FAQItem = styled.div`
  background: #ffffff;
  margin: 15px 0;
  border-bottom: 1px solid #d1d5db;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  transform: translateY(20px);
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};

  &:hover {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
`;


const Question = styled.div`
  background: #f9fafb;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: #eef1f6;
  }
`;

const Answer = styled.div`
  padding: 15px;
  font-size: 16px;
  color: #555;
  background: #ffffff;
  border-top: 1px solid #d1d5db;
  animation: ${fadeIn} 0.5s ease-in-out;
`;


const Icon = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #E60000;
  transition: transform 0.3s ease;
  ${({ isOpen }) => isOpen && "transform: rotate(180deg);"}
`;


const LeftSection = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  max-height: 400px;
  animation: ${slideInLeft} 1s ease-in-out;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease-in-out;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;


const ExperienceBadge = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: linear-gradient(to right, #228B22, #E60000);
  color: white;
  padding: 10px 18px;
  font-size: 18px;
  font-weight: bold;
`;


const faqData = [
  { question: "Etes-vous membres de l'ordre des experts-comptables?", answer: "CINEF-EC est une société d'expertise-comptable membre de l'ordre des Experts-Comptbales et Comptables agréés du Bénin sous le numéro OECCA-BENIN 299-EC." },
  { question: "Quelles sont les missions et services proposés par CINEF-EXPERTISE COMPTABLE ?", answer: "Nos experts-comptables vous offrent un accompagnement complet : comptabilité (bilan, compte de résultat...), fiscalité (TVA, déclarations...), audit (certification des comptes par nos commissaires aux comptes), juridique (création, immatriculation...) et social (paie, déclarations...). Concentrez-vous sur votre activité, nous gérons l'essentiel." },
  { question: "Quelle est la valeur ajoutée de CINEF-EC ?", answer: "Au-delà de l'expertise comptable, notre valeur ajoutée réside dans notre capacité à vous conseiller. Nous vous apportons un éclairage essentiel pour atteindre vos objectifs et relever vos défis de dirigeant : gestion des risques, optimisation de votre situation personnelle et professionnelle, évaluation de votre entreprise, structuration de votre patrimoine et bien plus encore." },
  { question: "Comment garantissez-vous la confidentialité des données ?", answer: "En tant que membre d'une profession réglementée et soumis à une déontologie stricte,   CINEF-EC vous garantit une confidentialité et une impartialité totale dans le traitement de vos informations, conformément aux exigences de l'Ordre des Experts-Comptables et sous sa supervision." },
  { question: "Qui peut-etre client de CINEF-EC ?", answer: "Des entreprises de toute taille (Très petites entreprises (TPE) - Petites et moyennes entreprises (PME) - Entreprises de taille intermédiaire (ETI), Grandes entreprises) et de divers secteurs d'activité (Commerce (détail et gros) - Artisanat - Bâtiment et Travaux Publics (BTP) - Industrie (manufacturière, agroalimentaire, etc.) - Services (consulting, informatique, communication, transport, logistique, etc.) - Professions libérales (médecins, avocats, architectes, experts, etc.) - Agriculture - Hôtellerie et Restauration - Secteur de la santé (cliniques, pharmacies, etc.) - Immobilier (agences, promoteurs, etc.) - Éducation et formation - Art, Culture et divertissement - Secteur associatif et organisations à but non lucratif - Énergies renouvelables - Nouvelles technologies et startups La cible de   CINEF-EC est donc toute entité économique ayant des obligations comptables, fiscales, sociales et/ou juridiques, et qui a besoin d'un accompagnement professionnel pour gérer ces aspects et optimiser sa performance.", },
  { question: "Comment fonctionne notre tarification ?", answer: "Nous comprenons que chaque projet est différent. C'est pourquoi notre structure tarifaire est conçue pour s'adapter précisément à la complexité des missions qui nous sont confiées. Nous vous invitons à nous contacter afin d'étudier votre projet et de vous fournir un devis personnalisé et transparent." },
];


const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  
  useEffect(() => {
    const handleScroll = () => {
      const faqSection = document.getElementById("faq-section");
      if (faqSection) {
        const rect = faqSection.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8 && rect.bottom > 0) {
          setIsVisible(true);
        } else {
          setIsVisible(false); 
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    
    <Wrapper id="faq-section" className={isVisible ? "visible" : ""}>
      
      <Title>
        Trouvez des <span>réponses</span> à vos questions
      </Title>

      <FAQContainer>
        
        <LeftSection>
          <img src={faqImage} alt="Équipe Cinef Expertise en réunion" />
          <ExperienceBadge>+10 ans d'expertise</ExperienceBadge>
        </LeftSection>

        
        <FAQContent>
          {faqData.map((faq, index) => (
            <FAQItem key={index} delay={`${index * 0.2}s`}>
              <Question onClick={() => toggleFAQ(index)}>
                {faq.question}
                <Icon isOpen={activeIndex === index}>{activeIndex === index ? "−" : "+"}</Icon>
              </Question>
              {activeIndex === index && <Answer>{faq.answer}</Answer>}
            </FAQItem>
          ))}
        </FAQContent>
      </FAQContainer>
    </Wrapper>
  );
};

export default FAQ;
